import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import propTypes from './prop'
import ListSchema from './list'
import List from '../list'
import { ListUseModeType } from '../../model/list'
import { TeamEmptyState } from './components'
import { useSelector } from 'react-redux'

class CollaboratorsListContainer extends Component {
  static defaultProps = {
    hideTopBar: true,
    hideSearchBar: true,
    showPaging: true,
    showSelect: false,
    showChildList: false,
    usageMode: ListUseModeType.LIST,
    showDetailSearch: false,
    ShowNoDataComponent: () => <TeamEmptyState />,
    query: {
      currentPage: 0,
      pageSize: 0,
      asc: true,
      sortingColumn: 'id',
      filterText: 'string',
      filters: [],
    },
  }

  /**
   *
   */
  render() {
    let newQuery = {
      currentPage: 0,
      pageSize: 20,
      asc: true,
      sortingColumn: 'id',
      filterText: 'string',
      filters: [],
      id: this.props.match.params.id,
    }

    return (
      <div>
        <List
          list={ListSchema}
          disabled={false}
          {...this.props}
          query={newQuery}
        />
      </div>
    )
  }
}

CollaboratorsListContainer.propTypes = propTypes

const mapStateToProps = response => {
  return {
    queryResult: response.collection.collaboratorsList,
  }
}

export default connect(mapStateToProps)(withRouter(CollaboratorsListContainer))
